
        var result = require("!!../../../node_modules/css-loader/index.js!./tnc.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/tnc/tnc.component.css
// module id = 460
// module chunks = 2